



























import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import BaseApi from "@/core/HttpResources/BaseApi";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import { AxiosResponse } from "axios";

@Component({})
export default class BaseSelectUserComponent extends Vue {
  @Prop() public label!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public placeholder!: string;
  @Prop() public disabled!: boolean;
  @Prop({ default: true }) public multiple!: boolean;
  @Prop() public value: any;
  @Prop() public initOnDisable!: boolean;
  @Prop() public hideSelected!: boolean;
  protectedrepository: BaseRepository<any> = new BaseRepository<any>("Usuario");
  customLabel({ id, full, email }: any) {
    return `${email}`;
  }
  get sAction() {
    return this.action ? "/" + this.action : "";
  }
  selected: any = null;
  data: any[] = [];
  loading: boolean = false;
  nombre = "";
  timerFunction: any;

  getAll(value?: any) {
    this.loading = true;
    let url = `Usuario`; //`${this.controller}${this.sAction}`;
    let baseApi = new BaseApi(url);

    baseApi.apiUrl += `?perpage=5&where=email.Contains("${this.nombre}") || userName.Contains("${this.nombre}") || cedula.Contains("${this.nombre}")`;

    if (this.timerFunction) {
      clearTimeout(this.timerFunction);
    }

    if (this.nombre) {
      this.timerFunction = setTimeout(() => {
        baseApi.request(
          "get",
          String(),
          null,
          {},
          (response: AxiosResponse) => {
            let data = response.data as BaseModel[];
            let aux_complete_object = data.map((x: any) => {
              return {
                id: x.id,
                full: x.cedula + x.email,
                email: x.email,
                userName: x.userName
              };
            });
            this.data = aux_complete_object;
            // if (this.data.length > 0) {
            //   if (data) {
            //     for (let i = 0; i < aux_complete_object.length; i++) {
            //       if (!this.data.some(x => x.id == aux_complete_object[i].id))
            //         this.data.push(aux_complete_object[i]);
            //     }
            //   }
            // } else {
            //   if (data) {
            //     this.data = aux_complete_object;
            //   }
            // }

            this.loading = false;
            this.$emit("onLoad", data);
            this.$emit("load-success", response, data);
          },
          (response: AxiosResponse) => {
            this.loading = false;
            this.$emit("load-error", response);
          },
          (response: AxiosResponse) => {
            this.$emit("load-finally", response);
          }
        );
      }, 500);
    }
  }

  searchChange(text: string) {
    this.nombre = text;
    this.$emit("searchChange", text);
  }

  @Watch("selected")
  onSelectChange() {
    this.$emit("input", this.selected);
  }

  @Watch("value", { immediate: true })
  onValueChange(value: any) {
    if (this.value && this.value.length) {
      if (this.value.length == 0 && this.value != this.selected) {
        this.selected = [];
      }
    }
    if (this.value == null) this.selected = [];
  }

  @Watch("nombre")
  onNombreChange(value?: string) {
    if (value) {
      this.getAll(value);
    }
  }
}
